<template>
  <div>
    <StationSelector></StationSelector>

    <div class="field-card" v-if="display_station">
      <!-- 縮時攝影 / 單張照片：若花期結束將 display_one_photo 設為 true，則只顯示單張照片 -->
      <div class="card-layout-full">
        <Slider
          :key="display_station.id"
          :display_one_photo="true"
          :field_id="display_station.id"
          :field_name="display_station.name"
        ></Slider>
      </div>

      <div class="card-layout">
        <h3 class="title mb-4">
          <div class="field-name">
            {{ $t("field.location_" + display_station.id) }}
          </div>
          <div class="crop-name">
            {{ $t("field.name_" + display_station.id) }}
          </div>
        </h3>

        <template v-if="showRealtime">
          <div class="sub-title">{{ $t("menu.realtime_data") }}</div>
          <div class="dashboard-update-info" v-if="field_data">
            <i class="fas fa-sync faa-spin animated faa-slow"></i>
            {{ $t("menu.updated_at") }}：
            {{ DateTools.Get_DateTimeZone(field_data.log_time) }}
          </div>
          <div>
            <LoadingInfo v-if="loading"></LoadingInfo>
            <div class="dashboard" v-if="field_data">
              <template
                v-for="(param_value, param_key, idx_pa) in field_data.values"
              >
                <div
                  class="sensor-block"
                  v-if="filter_Params(param_key)"
                  :key="idx_pa"
                >
                  <div class="sensor-icon">
                    <i
                      :class="Get_SensorIcon(param_key) + ' '"
                      :style="Get_SensorColor(param_key)"
                    ></i>
                  </div>
                  <div class="sensor-value" :style="Get_SensorColor(param_key)">
                    <div class="sensor-number">
                      <span v-if="param_key == 'wind_speed'">
                        {{ param_value }}
                      </span>

                      <span v-else-if="param_key == 'rainfalls'">
                        <!-- show nothing -->
                      </span>

                      <span v-else-if="param_key == 'solar_radiation'">
                        {{ param_value }}
                      </span>

                      <span v-else-if="param_value > -99">{{ param_value }}</span>

                      <span v-else><i class="fa fa-minus"></i></span>
                    </div>
                    <template v-if="showSensorUnit(param_key)">
                      <div class="sensor-unit">
                        <div v-html="Get_SensorUnit(param_key)"></div>
                      </div>
                    </template>
                    <div class="sensor-tip">
                      <span v-if="param_key == 'rain_rate'">{{
                        field_data.values["rainfalls"]
                      }}</span>
                      <span v-else>{{
                        Get_SensorTip(param_key, param_value)
                      }}</span>
                    </div>
                  </div>
                  <div class="sensor-param">
                    {{ Get_SensorName(param_key) }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>

        <div class="info-block">
          <Forecast
            :field_id="display_station.id"
            :user_language="user_language"
          ></Forecast>
        </div>

        <b-row>
          <!-- <b-col md="6" class="info-block">
            <div class="sub-title">{{ $t("menu.line_group") }}</div>
            <div class="mt-2">
              <QRCreater
                v-if="display_station.line_qrcode_url != undefined"
                :type="'line_group'"
                :size="160"
                :text="display_station.line_qrcode_url"
                :title="display_station.location"
                :sub_title="`${display_station.name}`"
              ></QRCreater>

              <div class="qrcode-info">
                <div>
                  {{ $t("menu.join_line_group_description") }}
                </div>
                <b-button
                  variant="primary"
                  :href="display_station.line_url"
                  rel="noopener noreferrer"
                  class="qrcode-btn"
                >
                  <i class="fas fa-mobile-alt"></i>
                  {{ $t("menu.line_group_button_for_phone") }}
                </b-button>
              </div>
            </div>
          </b-col> -->

          <b-col md="12" class="info-block">
            <div class="sub-title">{{ $t("menu.traffic") }}</div>

            <div class="traffic-info">
              <h5 class="my-2">
                {{ $t("field.location_" + display_station.id) }}
                {{ $t("field.name_" + display_station.id) }}
              </h5>
              <div class="mb-2">
                <i class="fas fa-map-marker-alt"></i>
                {{ $t("field.address_" + display_station.id) }}
              </div>

              <div>
                <iframe
                  width="100%"
                  height="250"
                  :src="getMapSource()"
                  style="border: 0; max-width: 450px"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DateTools from "@/tools/date";
import LoadingInfo from "@/components/LoadingInfo";
import QRCreater from "@/components/QR_Creater";
import StationSelector from "./Station_Seletor";
import Slider from "./Image_Slider";
import Forecast from "./Station_Forecast";

export default {
  props: {
    autoUpdate: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoadingInfo,
    QRCreater,
    StationSelector,
    Slider,
    Forecast,
  },
  data() {
    return {
      DateTools: DateTools,

      loading: false,
      field_data: undefined,

      // 自動更新計時
      timer: "",
      autoUpdateMinutes: 1 * 60, // 一小時更新一次
    };
  },
  created() {
    if (this.autoUpdate) {
      let _intervalTime = this.autoUpdateMinutes * 60 * 1000;
      this.timer = setInterval(this.get_Field_Data, _intervalTime);
    }
  },
  mounted() {
    this.get_Field_Data();
  },
  computed: {
    ...mapState({
      display_station: (state) => state.data.display_station,
      user_language: (state) => state.user.language,
      googleMapKey: (state) => state.system.googleMapKey,
    }),

    // NOTE - 如果沒有即時資料或是即時資料的最後更新時間超過七天前，就不顯示即時資料
    showRealtime() {
      if (!this.field_data) return false;

      const EXPIRATION_DAYS = 7;
      const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

      const last_update_time = new Date(this.field_data.log_time);
      const now = new Date();
      const diff_in_days = (now - last_update_time) / MILLISECONDS_PER_DAY;

      return diff_in_days <= EXPIRATION_DAYS;
    },
  },
  watch: {
    display_station() {
      this.get_Field_Data();
    },

    user_language() {
      this.get_Field_Data();
    },
  },
  methods: {
    getMapSource() {
      if (this.display_station.map_placeID != undefined) {
        return `https://www.google.com/maps/embed/v1/place?key=${this.googleMapKey}&q=${this.display_station.map_placeID}`;
      }

      return this.display_station.map_src;
    },

    filter_Params(param) {
      switch (param) {
        case "air_temperature":
          return true;
        case "air_humidity":
          return true;
        case "rain_rate":
          return true;
        case "wind_speed":
          return true;
        case "solar_radiation":
          return true;
        default:
          return false;
      }
    },

    // 取得即時感測數值
    get_Field_Data() {
      this.loading = true;
      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Field_Realtime", {
          fieldID: this.display_station.id,
        }),
      };
      this.$http(options)
        .then((res) => {
          // console.log( res.data )
          let _reorder_data = res.data.realtime;

          // 為了固定順序，把參數數值都放進 values:{} 內
          _reorder_data.values = {
            air_temperature: res.data.realtime["air_temperature"],
            air_humidity: res.data.realtime["air_humidity"],
            rainfalls: res.data.realtime["rainfalls"],
            rain_rate: res.data.realtime["rain_rate"],
            wind_speed: res.data.realtime["wind_speed"],
            solar_radiation: res.data.realtime["solar_radiation"],
          };

          this.field_data = _reorder_data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    showSensorUnit(sensor_param) {
      if (sensor_param == "rainfalls") return false;
      if (sensor_param == "wind_speed") return false;
      if (sensor_param == "solar_radiation") return false;
      return true;
    },

    // 從 Vuex 取得感測參數的設定
    Get_SensorColor(sensor_param) {
      return {
        color: "#2c2c2c",
        // color: this.$store.getters['data/get_SensorColor'](sensor_param),
      };
    },
    Get_SensorIcon(sensor_param) {
      return `${this.$store.getters["data/get_SensorIcon"](sensor_param)}`;
    },
    Get_SensorName(sensor_param) {
      return this.$t("sensor." + sensor_param);
      // return `${ this.$store.getters['data/get_SensorName'](sensor_param) }`
    },
    Get_SensorUnit(sensor_param) {
      return `${this.$store.getters["data/get_SensorUnit"](sensor_param)}`;
    },
    Get_SensorTip(sensor_param, value) {
      switch (sensor_param.toLowerCase()) {
        case "rainfalls":
          return `${this.$store.getters["data/get_Rainfall_Tip"](value)}`;
        default:
          return "";
      }
    },
  },
  beforeDestroy() {
    // Cancel Auto Update
    if (this.autoUpdate) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
$flowering-color: #fe6357;
$blooming-color: #232175;

.card-layout {
  width: 100%;
  padding: 15px 20px 0px 20px;
  margin-bottom: 15px;
  font-size: 1rem;
}

.card-layout-full {
  margin-bottom: 15px;
}

.field-card {
  margin: 0px 5px 10px 0px;
  border-radius: 6px;
  border: 1px solid #dcd9d9;

  .title {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .sub-title {
    display: inline-block;
    padding: 3px 10px;
    color: $blooming-color;
    background-color: rgba($flowering-color, 0.3);
    font-weight: bold;
    border-radius: 2px;
    margin-right: 10px;
  }
  .field-name {
    display: inline-block;
    margin-right: 20px;
    color: #585858;
  }
  .crop-name {
    display: inline-block;
    color: $blooming-color;
  }
  .fa-minus {
    margin: 0px 5px;
  }
}

.traffic-info {
  margin-top: 15px;

  .fa-map-marker-alt {
    color: rgb(171, 40, 40);
  }
}

.qrcode {
  width: 35%;
  border-radius: 15px;
  margin-right: 10px;

  @media screen and (max-width: 770px) {
    max-width: 120px;
    margin-bottom: -10px;
  }
}
.qrcode-info {
  display: inline-block;
  width: 60%;
  vertical-align: middle;
}
.qrcode-btn {
  padding: 5px 10px;
  .fa-mobile-alt {
    color: $flowering-color;
    font-size: 1.5rem;
    vertical-align: middle;
    margin-top: -3px;
    margin-right: 5px;
  }
}

.dashboard-update-info {
  display: inline-block;
  font-size: 0.8rem;
  line-height: 1.2rem;
  margin-top: 5px;
  margin-bottom: 15px;
  color: #848780;
  i {
    width: 25px;
    text-align: center;
    color: $flowering-color;
  }

  .station-info {
    display: inline-block;
  }
}
.dashboard {
  margin-left: -5px;
  margin-bottom: 30px;
  text-align: center;
  background-color: rgba($blooming-color, 0.1);
  border: 1px solid rgba($blooming-color, 0.5);
  border-radius: 5px;
  padding: 14px 0px 8px 0px;

  .sensor-block {
    display: inline-block;
    margin-right: 30px;
    min-width: 16%;
    text-align: center;

    .sensor-icon {
      display: inline-block;
      font-size: 1.8rem;
      text-align: center;
      width: 50px;

      @media screen and (max-width: 770px) {
        font-size: 1.4rem;
        width: 40px;
      }
    }
    .sensor-value {
      display: inline-block;

      .sensor-number {
        display: inline-block;
        font-size: 1.6rem;
        font-weight: 600;
        margin-right: 5px;

        @media screen and (max-width: 770px) {
          font-size: 1.6rem;
        }
      }
      .sensor-unit {
        display: inline-block;
        font-size: 0.8rem;
        margin-right: 5px;
      }
      .sensor-tip {
        display: inline-block;
        font-size: 1.2rem;
        font-weight: 600;

        @media screen and (max-width: 770px) {
          font-size: 1rem;
        }
      }
    }
    .sensor-param {
      margin-left: 50px;
      margin-top: -8px;
      margin-bottom: 10px;
      color: #767657;

      @media screen and (max-width: 770px) {
        margin-left: 40px;
        font-size: 0.8rem;
      }
    }
  }
}

.info-block {
  margin-bottom: 40px;
}
</style>
